exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body {\n  height: 100vh !important;\n}\n\n.IA_app_21J9ao5CoN-4X1ZWg-C5Dr {\n  width: 100%;\n  height: 100vh;\n  left: 0;\n  overflow: hidden;\n}\n\niframe {\n  border: none;\n  outline: none;\n  background-color: transparent;\n}", ""]);

// Exports
exports.locals = {
	"IA_app": "IA_app_21J9ao5CoN-4X1ZWg-C5Dr"
};